module.exports = __webpack_public_path__ + "static/media/galdisa_acerca_de_seguridad_alimentaria.ebad7255.jpg";